import React from 'react';

const DirectoryLettersSkeleton: React.FC = () => {
  // Create 27 skeleton buttons to match the full alphabet + # symbol
  const skeletonButtons = Array.from({ length: 27 });

  return (
    <div className="grid w-full mb-6 gap-1 md:gap-2 justify-items-center [grid-template-columns:repeat(auto-fit,minmax(2rem,1fr))]">
      {skeletonButtons.map((_, index) => (
        <div
          key={index}
          className="w-8 h-8 bg-gray-200 rounded-md animate-pulse flex items-center justify-center text-sm font-medium transition-transform"
        />
      ))}
    </div>
  );
};

export default DirectoryLettersSkeleton;
